export default function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_filter.js
// module id = ptuo
// module chunks = 22